import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import { useContext, useRef, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider.jsx";
import { FormContext } from "../context/FormProvider.jsx";
import * as Messages from "../messages/messages.js";
import {
  useAddLetter,
  useRemoveLetter,
} from "../Slides/Hooks/authorizationLetterQueries.jsx";
import "../styles/form-container.css";
import "./styles/new-select.css";

// AuthorizationLetterField component is used to render a text input field for authorization letters
const AuthorizationLetterField = ({
  idProp,
  label,
  val,
  state,
  setState,
  setIsLoading,
  disabledInput,
  disabledInputMessage,
  invalidData,
  authLetters,
  isFetched,
}) => {
  const textRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { requestStatus, handleInputDisable } = useContext(FormContext);
  const { userId, clientId, projectId } = useContext(DashboardContext);

  const add_letter = useAddLetter(clientId, setState);
  const remove_letter = useRemoveLetter(clientId, setState);

  // Function to handle text input change
  const handleSelectChange = async (e) => {
    const { value } = e.target;
    if (value === "" && state[idProp]["id"] !== "") {
      setIsLoading(true);
      await remove_letter.mutateAsync({
        projectId: projectId,
      });
      setIsLoading(false);
    } else {
      setIsLoading(true);
      await add_letter.mutateAsync({
        projectId: projectId,
        letterId: value,
      });
      setIsLoading(false);
    }
  };

  return (
    <div className="select-info-container auth-info-container">
      <FormControl
        variant="outlined"
        id="select-form"
        classes={{ root: "form-select-root" }}
        className={`auth-form-control ${
          requestStatus === "RV" &&
          disabledInput === false &&
          invalidData &&
          (val === invalidData["initialValue"] || val === "")
            ? "revise-input"
            : requestStatus === "RV" &&
                disabledInput === false &&
                invalidData &&
                val !== invalidData["initialValue"] &&
                val !== ""
              ? "revised-input"
              : handleInputDisable(idProp, state, disabledInput, userId) ===
                  true
                ? "disable-text"
                : ""
        }`}
      >
        <InputLabel
          id="select-label"
          htmlFor="select-input"
          classes={{ shrink: "select-label-shrink" }}
          className={`${idProp}-select-field-label`}
        >
          {`${label}`}
        </InputLabel>
        <Select
          id="select-field"
          labelId="select-field-label"
          className={`${idProp}-input`}
          ref={textRef}
          label={`Add ${label}`}
          value={val}
          onChange={handleSelectChange}
          MenuProps={{
            id: "select-field-menu",
            className: "select-field-menu",
            classes: { paper: "select-field-paper" },
          }}
          inputProps={{
            id: "select-input",
            name: "select-input",
          }}
          disabled={
            handleInputDisable(idProp, state, disabledInput, userId) === true
              ? true
              : false
          }
          autoComplete="off"
          autoCapitalize="words"
          classes={{
            root: "select-field-root",
            input: "select-field-input",
          }}
        >
          <MenuItem
            value=""
            id="select-field-placeholder"
            className="select-placeholder"
          >
            Clear Field
          </MenuItem>
          {authLetters.map((letter) => (
            <MenuItem
              key={letter["id"]}
              value={letter["id"]}
              className="select-menu-item"
            >
              {`${letter["signer"]} (${letter["is_signed"] ? "Signed" : "Unsigned"})`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Tooltip
        id="tf-tooltip"
        classes={{
          tooltip: "text-field-tooltip",
          popper: "text-field-popper",
          arrow: "text-field-arrow",
          tooltipPlacementLeft: "text-field-right",
        }}
        title={Messages[`${idProp}Message`] || ""}
        placement={"top"}
        arrow
        open={open}
        sx={{
          backgroundColor: "rgb(0, 0, 0, 0.8) !important",
        }}
      >
        <InfoCircle
          className="text-info-circ"
          id={`info-${idProp}`}
          color="white"
          size={30}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        />
      </Tooltip>
    </div>
  );
};
export default AuthorizationLetterField;
